import "./timelineView.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import dependencyLineUtils from "./dependencyLineUtils";

const DependencyLine = props => {
  const { subjectPoint, objectPoint, lineColour, lineWidth, isViolated, isSubjectLeft, isObjectLeft } = props;
  const padding = lineWidth / 2;

  // styles: the svg container size and position
  const width = dependencyLineUtils.getTotalWidth(subjectPoint, objectPoint, padding);
  const height = dependencyLineUtils.getTotalHeight(subjectPoint, objectPoint, padding);
  const styles = {
    width: width,
    height: height,
    transform: `translate(${Math.min(subjectPoint.x, objectPoint.x)}px, ${Math.min(subjectPoint.y, objectPoint.y)}px)`
  };

  const pathDes = dependencyLineUtils.getDependencyPath(
    subjectPoint,
    objectPoint,
    isSubjectLeft,
    isObjectLeft,
    false,
    padding
  );
  // Decide the colour of the line
  const colourClassName = lineColour ? ` ${lineColour}` : isViolated ? " statusError" : " apple";

  return (
    <svg className={`dependencyLine${colourClassName}`} style={styles}>
      <path d={pathDes} fill="none" stroke="currentColor" strokeWidth={`${lineWidth}px`} />
    </svg>
  );
};

DependencyLine.defaultProps = {
  lineWidth: 1,
  isViolated: false
};

DependencyLine.propTypes = {
  subjectPoint: PropTypeShapes.point.isRequired,
  isSubjectLeft: PropTypes.bool.isRequired,
  objectPoint: PropTypeShapes.point.isRequired,
  isObjectLeft: PropTypes.bool.isRequired,
  lineColour: PropTypes.string,
  lineWidth: PropTypes.number.isRequired,
  isViolated: PropTypes.bool.isRequired
};

export default DependencyLine;
